import React, { useState } from 'react';

// A coach sends a gymnast's routine back with a note saying what to change.
// onSend(note) resolves when sent, or rejects to keep the dialog open.
export default function SendBackDialog({ routine, onSend, onCancel }) {
  const [note, setNote] = useState(routine.reviewNote || '');
  const [sending, setSending] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await onSend(note.trim());
    } catch {
      setSending(false);
    }
  };
  return (
    <div className="modal-overlay">
      <form className="modal" style={{ maxWidth: 460 }} onSubmit={submit}>
        <div className="modal-header">
          <h3>Send back {routine.name}</h3>
          <button type="button" onClick={onCancel} className="close-button" aria-label="Close">×</button>
        </div>
        <label className="form-group" style={{ display: 'block' }}>
          What should {routine.gymnast?.firstName || 'the gymnast'} change?
          <textarea
            className="form-control"
            rows={3}
            maxLength={1000}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="e.g. Skill 2 should be a barani, not a half out"
            autoFocus
          />
        </label>
        <p className="text-muted" style={{ fontSize: '0.85rem' }}>
          They'll see this on their routine. It comes back to be checked when they change it.
        </p>
        <div className="modal-actions">
          <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={sending}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={sending || !note.trim()}>
            {sending ? 'Sending…' : 'Send back'}
          </button>
        </div>
      </form>
    </div>
  );
}
